import React, { useContext } from 'react'
import { LocaleContext } from '../../utils/context'
export const useLocale = () => {
    const { locale } = useContext(LocaleContext)
    if (locale) return locale
    else return 'ja-JP'
}